module.exports = __webpack_public_path__ + "static/media/img4.b22d3ea3.jpeg";